import React, { createElement } from 'react';
import { getIcon } from 'src/utils/category.utils';
import styles from './iconContainer.module.scss';
import Circle from 'src/components/atomic/atoms/circle/Circle';
import Selectors from 'src/utils/selectors';

const icons: any = {
    Charity: {
        className: styles.charity
    },
    Education: {
        className: styles.education
    },
    Family: {
        className: styles.family
    },
    Financial: {
        className: styles.financial
    },
    'Food & Dining': {
        className: styles.food
    },
    'Fun & Entertainment': {
        className: styles.entertainment
    },
    'Health & Wellness': {
        className: styles.health
    },
    Home: {
        className: styles.home
    },
    Services: {
        className: styles.services
    },
    Shopping: {
        className: styles.shopping
    },
    'Travel & Transportation': {
        className: styles.travel
    },
    'Needs Categorization': {
        className: styles.uncategorized
    },
    Miscellaneous: {
        className: styles.miscellaneous
    }
};

interface IconContainerProps {
    isMinWidthSmall?: boolean;
    categoryName?: string;
    parentName?: string;
}

export default function IconContainer({ isMinWidthSmall, categoryName, parentName }: IconContainerProps): JSX.Element {
    const isSubcategory: boolean = !!parentName;
    const outerCircleDiameterLg: string = isMinWidthSmall ? '48px' : '32px';
    const innerCircleDiameter: string = '12px';
    const Icon: JSX.Element = isSubcategory ? null : createElement(getIcon(categoryName), { className: styles.icon });

    return !isSubcategory ? (
        <Circle
            className={icons[categoryName]?.className}
            diameter={outerCircleDiameterLg}
            data-cy={Selectors.SpendSmart.ICON_CONTAINER_PARENT}
        >
            {Icon}
        </Circle>
    ) : isMinWidthSmall ? (
        <div className={styles.subcategoryCircle}>
            <Circle
                className={icons[parentName]?.className}
                diameter={innerCircleDiameter}
                data-cy={Selectors.SpendSmart.ICON_CONTAINER_SUBCATEGORY}
            />
        </div>
    ) : null;
}
